import React,{useCallback, useEffect, useRef, useState} from 'react'
import './SHeader.css';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import { LoginService } from '../services/LoginService';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../reducers';
import eventBus from '../doctorapprover/eventBus';
import { Divider } from 'primereact/divider';
import { fetchDoctorDatasss } from '../reduxactions/doctoractions/DoctorProfileActions';
type Nullable<T> = T | null;

var imageuser = require('../assets/img/medi.png');
var projecticon = require('../assets/img/medicaaal.png');
var defaultimage = require('../assets/img/images.png');


export const DHeader = () => {
    const op = useRef(null as any);
    const photos = window.sessionStorage.getItem('photo');
    const uid = window.sessionStorage.getItem('uid');  
    const usertype = window.sessionStorage.getItem('usertype');
    const username = window.sessionStorage.getItem('username');
    const formattedUsertype = usertype ? usertype.charAt(0).toUpperCase() + usertype.slice(1).toLowerCase() : '';

    const [photo,setPhoto]=useState<any>(null);
    useEffect(()=>{
      if(photos !== photo){
        const photos = window.sessionStorage.getItem('photo');
        setPhoto(photos);
      }
    },[setPhoto,photo,photos]);
    const fetchSessionPhoto = useCallback(async () => {
      try {
        const photoUrl = window.sessionStorage.getItem('photo');
        setPhoto(photoUrl);
      } catch (error) {
        console.error('Error fetching session photo:', error);
      }
    }, []);
    useEffect(() => {
      const handlePhotoUpdate = (newPhoto:any) => {
        setPhoto(newPhoto);
      };
      eventBus.on('photoUpdated', handlePhotoUpdate);
  
      return () => {
        eventBus.off('photoUpdated', handlePhotoUpdate);
      };
    }, []);
    
    useEffect(() => {
      fetchSessionPhoto();
    
      const handleStorageChange = () => {
        if (window.sessionStorage.getItem('photo') !== photo) {
          fetchSessionPhoto();
        }
      };
    
      window.addEventListener('storage', handleStorageChange);
    
      return () => {
        window.removeEventListener('storage', handleStorageChange);
      };
    }, [fetchSessionPhoto, photo]);
  
    const handleLogout = () => {
      window.sessionStorage.removeItem('usertype');
    };
    const dispatch = useDispatch();
  const data = useSelector((state: RootState) => state.doctorprofile.data);
    useEffectOnce(() => {
      const fetchDataAsync = async () => {
        try {
          await dispatch(fetchDoctorDatasss(uid) as any);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
      fetchDataAsync();
    }, [dispatch]);



  return (

    <div className="layout-topbar" style={{ backgroundColor: '#007bff', color: 'black', display: 'flex', alignItems: 'center' }}>
      <div className="layout-topbar-logo" style={{ flex: 1 }}>
      {/* <span ><i className="pi pi-bars" style={{width:'40px'}}></i></span> */}
      {/* <span style={{marginLeft:'20px'}}> */}
      <span>
        <img src={imageuser} alt="Logo" width="50px" height="100%" />
        <img src={projecticon} alt="Logo" width="200px" height="100%" />
        </span>
        
      </div>
    
    
          {/* <a  className="nav-link"  onClick={(e) => op.current.toggle(e)} style={{textDecoration: 'none', marginLeft: '15px',float:'right'}}>
          <img src={photo || defaultimage} className="avatar" alt="User Image" style={{width:'50px',height:'50px'}} />
            <span className="hidden-xs" style={{color: 'black', fontSize: '1.2rem',fontWeight:'400',fontFamily: 'Source Sans Pro, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif'}}>{username} - {formattedUsertype}</span>
          </a> */}

                    <a  className="nav-link"  onClick={(e) => op.current.toggle(e)} style={{textDecoration: 'none', marginLeft: '15px',float:'right'}}>
                    <img src={photo || defaultimage} className="avatar" alt="User Image" />
                      <span className="hidden-xs" style={{color: 'white', fontSize: '1.2rem',fontWeight:'400',fontFamily: 'Source Sans Pro, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif',marginLeft:'10px'}}>{username} - {formattedUsertype}</span>
                    </a>
    
      <ul className="navbar-nav ml-auto">
        <OverlayPanel ref={op}>
          <div className="dropdown-divider"></div>

          <a className="dropdown-item" style={{textDecoration: 'none'}}>
            <div className="media">
            <a href={`${process.env.PUBLIC_URL}/doctorprofile`} style={{ textDecoration: 'none' }}>Profile</a>
                <Divider />
                 <a href={`${process.env.PUBLIC_URL}/doctorresetpassword`} style={{ textDecoration: 'none'}}>Reset Password</a>
                 <Divider />
                 <a href="/" style={{textDecoration: 'none'}}>Sign out</a>
              {/* <a href="/doctorprofile" style={{textDecoration: 'none'}}>Profile</a>
              <Divider />
              <a href="/dresetpassword" style={{textDecoration: 'none'}}>Reset Password</a>
              <Divider />
              <a href="/" style={{textDecoration: 'none'}}>Sign out</a> */}
              </div>
              </a>
        </OverlayPanel>
      </ul>
    </div>
    

    );
};

DHeader.displayName = 'AppTopbar';

export default DHeader;

